/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {CCInbox} from "@app/ir-q-app-common/types/message-api";
import {MessagingModule} from "@modules/MessagingModule";
import {COLORS} from "@res/colors";
import * as React from "react";
import {useContext} from "react";
import {hideTooltip, showTooltip} from "../../../widget/appTooltip";
import {GroupType} from "@app/ir-q-app-common/types/contacts";
import {messagingTableRowHeight} from "../Page_Messages";
import {backgroundCell} from "../InboxTable";
import {ContactsContext} from "../ContactsContext";

type Props = {
    chat: CCInbox
    isOpen: boolean
}

export const InfoCell = (props: Props) => {
    const contactContext = useContext(ContactsContext)

    const chat = props.chat
    const chatContacts = chat.contactIds.map(cId => contactContext.contacts[cId]);

    let backgroundColor = "transparent";
    if (MessagingModule.getNumberOfUnreadMessages(chat))
        backgroundColor = "#fffaf0";
    if (props.isOpen)
        backgroundColor = COLORS.primary_light_blue;

    return <div className={`ll_h_c clickable ${backgroundCell(backgroundColor)}`} style={{height: messagingTableRowHeight, justifyContent: props.isOpen ? "inherit" : "center"}}>
        {props.isOpen && <div style={{border: "solid", color: COLORS.primary_dark_blue, height: "-webkit-fill-available", marginRight: 5}}/>}
        <div style={{
            backgroundColor: chatContacts.find(contact => contact.contactType === "group")?.contactData.type === GroupType.CUSTOMER_SERVICE ? "orange" : "blue",
            width: "7px",
            height: "7px",
            borderRadius: 10
        }} onMouseEnter={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const groupContact = chatContacts.find(contact => contact.contactType === "group");
            showTooltip(e, <p>{groupContact?.contactData.type === GroupType.CUSTOMER_SERVICE ? "Customer Service" : groupContact?.firstName}</p>,
                rect.left,
                rect.bottom + 10,
                {
                    textAlign: "left",
                    backgroundColor: "white",
                    borderRadius: "4px",
                    transform: "translate(-100%)",
                    border: `1px solid ${COLORS.primary_light_blue}`
                });
        }}
             onMouseLeave={() => {
                 hideTooltip();
             }}/>
    </div>;
}
